<template>
    <v-container  class="align-start mt-3">
        <v-row align="center"> 
                <v-col style="max-width: 180px" cols="12" md="6">
                    <v-select
                        style="max-width: 150px"
                        :items="seasons"
                        v-model="currentSeason"
                        label="Season"
                        :hint="selectedYear"
                        persistent-hint
                        class="pa-3 pr-0"
                        dense
                    >
                    </v-select>
                </v-col>
                <v-col style="max-width: 180px" cols="12" md="6">
                    <v-select
                        style="max-width: 150px"
                        :items="states"
                        v-model="stateFilter"
                        label="State"
                        :hint="selectedYear"
                        persistent-hint
                        class="pa-3 pr-0"
                        dense
                    >
                    </v-select>
                </v-col>
                <v-col style="max-width: 180px" cols="12" md="6" v-if="locations">
                    <v-select
                        style="max-width: 150px"
                        :items="allLocations"
                        item-text="name"
                        item-value="id"
                        v-model="locationFilter"
                        label="Location"
                        class="pa-3 pr-0"
                        dense
                    >
                    </v-select>
                </v-col>
        </v-row>
        <v-col md="12" align="top">
            <v-data-table            
                :headers="headers"
                :loading="loading"                
                :items="sortedGames"
                :items-per-page="25"
                :footer-props="footerProps"
                :search="searchString"
                :custom-filter="filterGames"
                fluid
                class="elevation-1" 
            >
            <template v-slot:top>
                <v-autocomplete
                    v-model="search"
                    class="mx-4"
                    :items="sortedPlayers"
                    label="Search players"
                    item-text="name"
                    item-value="name"
                    multiple
                ></v-autocomplete>
                <v-radio-group
                    v-if="searchNumber > 1"
                    v-model="sameTeam"
                    row
                    class="mx-4"
                    >
                    <v-radio
                        label="Same game"
                        value="any"
                    ></v-radio>
                    <v-radio
                        label="Same team"
                        value="same"
                    ></v-radio>
                    <v-radio
                        v-if="searchNumber == 2"
                        label="Different teams"
                        value="opponents"
                    ></v-radio>
                </v-radio-group>
                <v-radio-group
                    v-if="sameTeam == 'same' && searchNumber > 1"
                    v-model="winOption"
                    row
                    class="mx-4"
                    >
                    <v-radio
                        label="Any result"
                        value="any"
                    ></v-radio>
                    <v-radio
                        label="Group won"
                        value="win"
                    ></v-radio>
                    <v-radio
                        label="Group lost"
                        value="lose"
                    ></v-radio>
                </v-radio-group>
            </template> 
            <template                
                v-slot:item.name="{ item }"
            >
                <td class="custom-max-width">
                    {{ item.name }}
                </td>
            </template>
            <template                
                v-slot:item.date="{ item }"
            >
                {{ getTime(item.date) }}
                <!-- {{ item.name.toUpperCase() }} -->
            </template>
            <template                
                v-slot:item.team1="{ item }"
            >
                {{ getTeam(item, 1) }}
                <!-- {{ item.name.toUpperCase() }} -->
            </template>
            <template                
                v-slot:item.team2="{ item }"
            >
                {{ getTeam(item, 2) }}
                <!-- {{ item.name.toUpperCase() }} -->
            </template>
            <template                
                v-slot:item.score="{ item }"
            >
                {{ item.team1_score + " - " + item.team2_score }}
                <!-- {{ item.name.toUpperCase() }} -->
            </template>
            <template
                v-slot:item.action="{ item }">
                <v-btn
                    icon
                    color="pink"
                    x-small
                    @click="editGame(item)"
                    >
                    <v-icon>mdi-circle-edit-outline</v-icon>
                </v-btn>

            </template>
            </v-data-table>
        </v-col>
        <edit-game :showDialog="dialog" :game="selectedGame" @closeDialog="dialog = false"></edit-game>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { format } from 'date-fns'
import { cloneDeep } from 'lodash'
import EditGame from '../components/EditGame.vue'
    export default {
        name: "Games",
        components: { EditGame },
        data() {
            return {
                currentSeason: "All",
                seasons: ["All"],
                states: ["All", "0", "1", "2", "3"],
                stateFilter: "All",
                locationFilter: "All",
                footerProps: {'items-per-page-options': [25, 50, 75, 100, -1]},
                headers: [
                    {
                        text: 'Time',
                        align: 'start',
                        sortable: false,
                        value: 'date',
                    },
                    { text: 'Name', value:"name", sortable: false, },
                    { text: 'Team 1', value:"team1", sortable: false, },
                    { text: 'Team 2', value:"team2", sortable: false, },
                    { text: 'Score', value:"score", sortable: false, },
                    { text: 'State', value:"state", sortable: false, },
                    { text: 'Shift', value:"elo", }
                ],
                dialog: false,
                selectedGame: null,
                search: [],
                sameTeam: 'any',
                winOption: 'any'
            }
        },
        methods: {
            getTime(time){                
                return format(new Date(time), "dd.MM.yyyy HH:mm")
            },
            getTeam(game, team){                
                let players = []
                for(let player of game.players){
                    if(player.team == team) players.push(player)
                }
                if(players.length == 3 && game.state >= 2){
                    let player1 = players[0].name + (players[0].elo ? " (" + players[0].elo + "), " : ", ")
                    let player2 = players[1].name + (players[1].elo ? " (" + players[1].elo + "), " : ", ")
                    let player3 = players[2].name + (players[2].elo ? " (" + players[2].elo + ")" : "")                
                    return player1 + player2 + player3
                }else return ""
            },
            editGame(game){
                this.selectedGame = game
                this.dialog = true
            },
            filterGames (value, search, item) {
                if(!search) return true
                else {
                    const searchNames = search.split(',');
                    if(this.sameTeam == 'any' || searchNames.length == 1)
                        return searchNames.every(name => item.players.some(player => player.name === name));
                    else if(this.sameTeam == 'same'){
                        const team1 = item.players.filter(player => player.team == 1)
                        const team2 = item.players.filter(player => player.team == 2)
                        switch(this.winOption) {
                            case 'any':
                                return searchNames.every(name => team1.some(player => player.name === name)) 
                                    || searchNames.every(name => team2.some(player => player.name === name));
                            case 'win':
                                return (searchNames.every(name => team1.some(player => player.name === name)) && item.team1_score == 2) 
                                    || (searchNames.every(name => team2.some(player => player.name === name)) && item.team2_score == 2);
                            case 'lose':
                                return (searchNames.every(name => team1.some(player => player.name === name)) && item.team1_score != 2) 
                                    || (searchNames.every(name => team2.some(player => player.name === name)) && item.team2_score != 2);
                            default:
                                return searchNames.every(name => team1.some(player => player.name === name)) 
                                    || searchNames.every(name => team2.some(player => player.name === name));
                            }
                    }
                    else if(this.sameTeam == 'opponents' && searchNames.length == 2){
                        const player1 = item.players.find(player => player.name == searchNames[0])
                        const player2 = item.players.find(player => player.name == searchNames[1])
                        return player1 && player2 && player1.team != player2.team
                    }
                    else
                        return false
                }
            },
        },
        watch: {
            gameStats: {
                deep: true,
                handler(){
                    this.seasons = ["All", ...Object.keys(this.gameStats.seasons)]
                }
            },
            token(){
                if(this.token && this.headers.length == 7){
                    this.headers.push( { text: 'Action', value: "action", sortable: false})
                }
            },
            search(newValue, oldValue){
                if(oldValue.length == 2 && this.sameTeam == 'opponents')
                    this.sameTeam = 'any'
            },
            sameTeam(newValue, oldValue){
                if(oldValue == 'same')
                    this.winOption = 'any'
            }
        },
        computed: {
            ...mapGetters(['gameStats', 'allGames', 'locations', 'token', 'sortedPlayers']),
            allLocations(){
                return [ {name: "All", id: "All"}, ...this.locations]
            },
            sortedGames(){
                let clone = cloneDeep(this.allGames)
                if(this.currentSeason != "All"){
                    const seasonsId = this.gameStats.seasons[this.currentSeason].id
                    clone = clone.filter(item => item.season == +seasonsId)
                }
                if(this.stateFilter != "All")
                    clone = clone.filter(item => item.state == +this.stateFilter)
                if(this.locationFilter != "All")
                    clone = clone.filter(item => item.location == +this.locationFilter)
                return clone.sort((a,b) => {
                    return new Date(b.date).getTime() - new Date(a.date).getTime()
                })
            },
            loading(){
                if(this.allGames.length == 0) return true
                else return false
            },
            selectedYear(){
                if(this.currentSeason != "All"){
                    return (2015 + +this.currentSeason).toString()
                }else {
                    return ""
                }
            },
            searchString(){
                return this.search.join(',')
            },
            searchNumber(){
                return this.search.length
            }
        },
        mounted(){
            this.seasons = Object.keys(this.gameStats.seasons) != 0 ? ["All", ...Object.keys(this.gameStats.seasons)]: ["All"]
            if(this.token && this.headers.length == 7){
                this.headers.push( { text: 'Action', value: "action", sortable: false})
            }
        }
    }
</script>

<style lang="scss" scoped>
.custom-max-width {
  max-width: 250px; 
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>